import { useState } from 'react'

const MAX_VALUE = 100
const MIN_VALUE = 1

export const useValuesDeclareFailure = <T>(initValue: T) => {
  const [values, setValues] = useState<T>(initValue)

  const validateValue = (value: string): string =>
    +value > MAX_VALUE
      ? MAX_VALUE.toString()
      : +value < MIN_VALUE
      ? value === ''
        ? ''
        : MIN_VALUE.toString()
      : value

  const handleChange = (value: string | boolean | null, name: keyof T) => {
    setValues((oldValues) => {
      if (String(value).includes('%')) {
        const valueWithOutSymbol = String(value).split('%')[0] ?? ''
        // Filtrar solo números
        const numericValue = valueWithOutSymbol.replace(/[^0-9]/g, '')

        return {
          ...oldValues,
          [name]: validateValue(numericValue),
        }
      }

      if (typeof value === 'string') {
        // Filtrar solo números
        const numericValue = value.replace(/[^0-9]/g, '')
        return {
          ...oldValues,
          [name]: validateValue(numericValue),
        }
      }

      return {
        ...oldValues,
        [name]: value,
      }
    })
  }

  const handleAddSymbol = (value: string, name: keyof T) => {
    setValues((oldValues) => {
      if (String(value).includes('%')) {
        const valueWithOutSymbol = String(value).split('%')[0]
        return {
          ...oldValues,
          [name]: `${valueWithOutSymbol}%`,
        }
      }
      return {
        ...oldValues,
        [name]: value.length > 0 ? `${value}%` : '',
      }
    })
  }

  const resetValues = () => setValues(initValue)

  return {
    handleAddSymbol,
    handleChange,
    resetValues,
    values,
  }
}
